export const aboutInfo = {
  brandName: '调教指南',
  tagline: '用科学塑造行为，以专业成就卓越',
  introduction: '「调教指南」成立于2020年，是国内领先的行为科学与技能训练知识平台。我们汇聚了来自动物行为学、心理学、教育学和运动科学领域的专家团队，致力于将前沿的行为调教理论转化为实用、可操作的训练方法，服务于训练师、教育者、宠物主人以及每一位追求自我提升的人。',
  mission: '我们的使命是让科学的行为调教方法触达每一个需要它的人。无论您是想训练一只听话的狗狗、培养孩子的良好习惯，还是希望突破自身的技能瓶颈，我们都希望通过专业、系统、温暖的内容，成为您最值得信赖的调教伙伴。',
  values: [
    {
      title: '科学为本',
      description: '所有内容均基于经过验证的行为科学理论，拒绝伪科学和未经证实的训练方法。',
      icon: 'ri-flask-line',
    },
    {
      title: '正向优先',
      description: '坚持以正强化为核心策略，倡导人道、尊重、积极的调教理念。',
      icon: 'ri-heart-line',
    },
    {
      title: '实用至上',
      description: '每个技巧、每篇文章都以"可执行"为标准，确保读者能够真正落地实践。',
      icon: 'ri-tools-line',
    },
    {
      title: '持续进化',
      description: '保持对最新研究的关注与学习，持续优化和更新我们的内容体系。',
      icon: 'ri-loop-left-line',
    },
  ],
  stats: [
    { value: '100+', label: '原创文章' },
    { value: '50万+', label: '月度读者' },
    { value: '6', label: '内容分类' },
    { value: '98%', label: '读者好评' },
  ],
  team: [
    {
      name: '陈思远',
      role: '创始人 & 首席训练师',
      bio: '动物行为学硕士，国际认证犬类训练师（CPDT-KA），10年宠物行为调教经验。',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20warm%20friendly%20Chinese%20man%20in%20his%2030s%20wearing%20casual%20professional%20attire%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20background%20with%20warm%20neutral%20tones%2C%20editorial%20portrait%20photography%20style&width=400&height=400&seq=team-1&orientation=squarish',
    },
    {
      name: '王知行',
      role: '行为科学顾问',
      bio: '心理学博士，研究方向为操作性条件反射与习惯形成机制，发表SCI论文20余篇。',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20thoughtful%20Chinese%20man%20in%20his%2040s%20with%20glasses%20wearing%20smart%20casual%20attire%2C%20soft%20studio%20lighting%2C%20clean%20minimalist%20background%20with%20warm%20neutral%20tones%2C%20editorial%20portrait%20photography%20style&width=400&height=400&seq=team-2&orientation=squarish',
    },
    {
      name: '张晓雯',
      role: '教育调教专家',
      bio: '儿童发展心理学硕士，正面管教认证讲师，专注于家庭场景中的行为引导研究。',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20warm%20smiling%20Chinese%20woman%20in%20her%2030s%20wearing%20professional%20casual%20attire%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20background%20with%20warm%20neutral%20tones%2C%20editorial%20portrait%20photography%20style&width=400&height=400&seq=team-3&orientation=squarish',
    },
    {
      name: '林小凡',
      role: '宠物行为顾问',
      bio: '兽医学博士，专攻猫科和犬科行为医学，拥有丰富的临床行为矫正经验。',
      avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20friendly%20Chinese%20woman%20in%20her%2030s%20with%20a%20warm%20expression%20wearing%20casual%20professional%20attire%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20background%20with%20warm%20neutral%20tones%2C%20editorial%20portrait%20photography%20style&width=400&height=400&seq=team-4&orientation=squarish',
    },
  ],
  contact: {
    email: 'contact@tiaojiao-guide.com',
    phone: '400-888-9999',
    address: '北京市朝阳区科学路88号行为科学大厦12层',
    wechat: 'tiaojiao_guide',
    workHours: '周一至周五 9:00 - 18:00',
  },
};